<template>
  <div>
    <a-card class="card" :loading="loading">
      <tk-flex middle between>
        <tk-flex middle>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="30"
            height="30"
            viewBox="0 0 30 30"
          >
            <defs>
              <linearGradient
                x1="0.5"
                y1="0"
                x2="0.5"
                y2="1"
                id="master_svg0_242_006032"
              >
                <stop offset="0%" stop-color="#FDC957" stop-opacity="1" />
                <stop offset="100%" stop-color="#FF8958" stop-opacity="1" />
              </linearGradient>
              <clipPath id="master_svg1_177_81505">
                <rect x="6" y="6" width="18" height="18" rx="0" />
              </clipPath>
            </defs>
            <g>
              <g>
                <ellipse
                  cx="15"
                  cy="15"
                  rx="15"
                  ry="15"
                  fill="url(#master_svg0_242_006032)"
                  fill-opacity="1"
                />
              </g>
              <g clip-path="url(#master_svg1_177_81505)">
                <g>
                  <path
                    d="M8.397088293945313,11.71991796875C7.832282293945313,12.14498796875,7.500076122284312,12.81077796875,7.5000762939453125,13.51766796875L7.5000762939453125,20.25041796875C7.500076465606313,21.49301796875,8.507436293945313,22.50041796875,9.750076293945312,22.50041796875L12.000076293945312,22.50041796875C12.414296293945313,22.50041796875,12.750086293945312,22.16461796875,12.750086293945312,21.75041796875L12.750086293945312,19.50041796875C12.750086293945312,18.25781796875,13.757436293945313,17.25040796875,15.000086293945312,17.25040796875C16.24272629394531,17.25040796875,17.250086293945312,18.25781796875,17.250086293945312,19.50041796875L17.250086293945312,21.75041796875C17.250086293945312,22.16461796875,17.58587629394531,22.50041796875,18.000076293945312,22.50041796875L20.250076293945312,22.50041796875C21.49277629394531,22.50041796875,22.500076293945312,21.49301796875,22.500076293945312,20.25041796875L22.500076293945312,13.51766796875C22.500076293945312,12.81077796875,22.167876293945312,12.14498796875,21.603076293945314,11.71991796875L16.35308629394531,7.76817596875C15.551866293945313,7.16516496875,14.448296293945312,7.16516496875,13.647076293945313,7.76817596875L8.397088293945313,11.71991796875Z"
                    fill="#FFFFFF"
                    fill-opacity="1"
                  />
                </g>
              </g>
            </g>
          </svg>
          <tk-flex middle>
            <div class="p-l-12 font-15 font-bold">{{ warehouse.name }}</div>
            <div class="card-tag">
              {{ warehouse.type == "square" ? "方仓" : "圆仓" }}
            </div>
          </tk-flex>
        </tk-flex>
        <a-dropdown
          v-if="
            can('viewGrainStorehouseModel') ||
              can('editGrainStorehouseModel') ||
              can('deleteGrainStorehouseModel')
          "
        >
          <a-icon type="more" />
          <template #overlay>
            <a-menu>
              <a-menu-item
                @click="showEditFunc(false)"
                v-if="can('viewGrainStorehouseModel')"
              >
                <div class="w-80p">基本信息</div>
              </a-menu-item>
              <a-menu-item
                @click="showEditFunc()"
                v-if="can('editGrainStorehouseModel')"
              >
                <div class="w-80p">编辑</div>
              </a-menu-item>
              <a-menu-item
                @click="showDele = true"
                v-if="can('deleteGrainStorehouseModel')"
              >
                <div class="color-red-del w-80p">删除</div>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </tk-flex>
      <a-row
        class="p-t-20 font-14 color-gray-card cursor-pointer"
        :gutter="[34, 20]"
        @click.native="$emit('click')"
      >
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">点位</div>
          <div>{{ pointNum }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">摄像头</div>
          <div>{{ eqNum }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">是否有虫</div>
          <div>{{ warehouse.bugNum > 0 ? "是" : "否" }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">含虫量</div>
          <div>{{ formatCompact(warehouse.bugNum) }}</div>
        </a-col>
        <a-col
          :xs="12"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="8"
          :xxl="8"
          v-if="warehouse.type === 'square'"
        >
          <div class="color-gray-cardtitle">长宽(米)</div>
          <div>{{ warehouse.length }} * {{ warehouse.width }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8" v-else>
          <div class="color-gray-cardtitle">直径(米)</div>
          <div>{{ warehouse.diameter }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="8">
          <div class="color-gray-cardtitle">最新检测时间</div>
          <div>{{ formatTimeShow(warehouse.testTime) }}</div>
        </a-col>
      </a-row>
    </a-card>
    <a-modal
    :maskClosable="false"
      :title="canEdit ? '编辑粮仓' : '基本信息'"
      :visible="showEdit"
      :confirm-loading="confirmEditLoading"
      @ok="canEdit ? handleEditOk() : handleEditCancel()"
      destroyOnClose
      @cancel="handleEditCancel"
    >
      <ak-type-input
        ref="name"
        key="name"
        v-model="formdata.name"
        :field="options[0]"
        style="width: 100%"
      />
      <ak-type-input
        ref="expectation"
        key="expectation"
        v-model="formdata.expectation"
        :field="options[1]"
        style="width: 100%"
      />
      <ak-type-input
        ref="reality"
        key="reality"
        v-model="formdata.reality"
        :field="options[2]"
        style="width: 100%"
      />
      <ak-type-input
        ref="type"
        key="type"
        v-model="formdata.type"
        :field="options[3]"
        style="width: 100%"
      />
      <ak-type-input
        ref="subtype"
        key="subtype"
        v-if="formdata.type == 'square'"
        v-model="formdata.subtype"
        :field="options[4]"
        style="width: 100%"
      />
      <ak-type-input
        ref="subtype2"
        key="subtype2"
        v-if="formdata.type == 'circle'"
        v-model="formdata.subtype"
        :field="options[5]"
        style="width: 100%"
      />
      <ak-type-input
        ref="length"
        key="length"
        v-if="formdata.type == 'square'"
        v-model="formdata.length"
        :field="options[6]"
        style="width: 100%"
      />
      <ak-type-input
        ref="width"
        key="width"
        v-if="formdata.type == 'square'"
        v-model="formdata.width"
        :field="options[7]"
        style="width: 100%"
      />
      <ak-type-input
        ref="height"
        key="height"
        v-if="formdata.type"
        v-model="formdata.height"
        :field="options[8]"
        style="width: 100%"
      />
      <ak-type-input
        ref="diameter"
        key="diameter"
        v-if="formdata.type == 'circle'"
        v-model="formdata.diameter"
        :field="options[9]"
        style="width: 100%"
      />
      <ak-type-input
        ref="grainType"
        key="grainType"
        v-model="formdata.grainType"
        :field="options[10]"
        style="width: 100%"
      />
      <ak-type-input
        ref="storageType"
        key="storageType"
        v-model="formdata.storageType"
        :field="options[11]"
        style="width: 100%"
      />
      <ak-type-input
        ref="incomeAt"
        key="incomeAt"
        v-model="formdata.incomeAt"
        :field="options[12]"
        style="width: 100%"
      />
      <ak-type-input
        ref="leaveAt"
        key="leaveAt"
        v-model="formdata.leaveAt"
        :field="options[13]"
        style="width: 100%"
      />
      <a-form-model
        ref="form"
        :model="formdata"
        :rules="{
          times: [{ validator: validateTimes, trigger: 'change' }]
        }"
      >
        <a-form-model-item ref="times" label="定时拍摄" prop="times">
          <tk-flex
            style="width: 100%"
            v-for="(item, index) in formdata.times"
            :key="item + index"
            class="m-b-10"
          >
            <a-time-picker
              :disabled="!canEdit"
              style="flex-grow: 1"
              class="flex-grow m-r-10"
              format="HH:mm"
              valueFormat="HH:mm"
              v-model="formdata.times[index]"
            />
            <a-button
              v-if="index === formdata.times.length - 1"
              @click="addTimes"
              :disabled="!canEdit"
              ><tk-flex middle
                ><a-icon type="plus" :style="{ fontSize: '14px' }"/></tk-flex
            ></a-button>
            <a-button v-else @click="deleteTimes(index)" :disabled="!canEdit"
              ><tk-flex middle
                ><a-icon type="minus" :style="{ fontSize: '14px' }"/></tk-flex
            ></a-button>
          </tk-flex>
        </a-form-model-item>
      </a-form-model>
      <ak-type-input
        ref="custodianUser"
        key="custodianUser"
        v-model="formdata.custodianUser"
        :field="options[14]"
        style="width: 100%"
      />
    </a-modal>
    <a-modal
    :maskClosable="false"
      :title="`确定要删除“${warehouse.name}”吗？`"
      :visible="showDele"
      destroyOnClose
      :confirm-loading="confirmDeleLoading"
      @ok="handleDeleOk"
      @cancel="handleDeleCancel"
    >
      <p>删除此粮仓将无法恢复，您要继续吗？</p>
    </a-modal>
  </div>
</template>
<script>
import { notEmpty } from '../../utils/validator'
import { formatCompact, formatTimeShow } from '../../utils/format.js'
import multipleTime from '../../assets/js/multipleTime'
export default {
  mixins: [
    multipleTime
  ],
  props: {
    warehouse: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      pointNum: 0,
      eqNum: 0,
      eqBugNum: 0,
      // delete modal
      showDele: false,
      confirmDeleLoading: false,
      // edit modal
      options: [
        {
          name: 'name',
          note: '粮仓名称',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'expectation',
          note: '设计储量(kg)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'reality',
          note: '实际储量(kg)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'type',
          note: '仓房类型',
          type: 'Select',
          validators: [notEmpty()],
          items: {
            square: '方仓',
            circle: '圆仓'
          }
        },
        {
          name: 'subtype',
          note: '方仓类型',
          type: 'Select',
          validators: [notEmpty()],
          items: {
            bungalow: '平房仓',
            otherSquare: '其他方仓'
          }
        },
        {
          name: 'subtype1',
          note: '圆仓类型',
          type: 'Select',
          validators: [notEmpty()],
          items: {
            shallow: '浅圆仓',
            bamboo: '筒仓',
            otherCircle: '其他圆仓'
          }
        },
        {
          name: 'length',
          note: '粮仓长度(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'width',
          note: '粮仓宽度(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'height',
          note: '粮面高度(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'diameter',
          note: '粮仓直径(米)',
          type: 'Number',
          validators: [notEmpty()]
        },
        {
          name: 'grainType',
          note: '粮食品种',
          type: 'Select',
          validators: [notEmpty()],
          items: {}
        },
        {
          name: 'storageType',
          note: '储量性质',
          type: 'Select',
          validators: [notEmpty()],
          items: {}
        },
        {
          name: 'incomeAt',
          note: '入仓时间',
          type: 'Date',
          span: 24,
          validators: [notEmpty()]
        },
        {
          name: 'leaveAt',
          note: '计划出仓时间',
          type: 'Date',
          span: 24,
          validators: []
        },
        {
          name: 'custodianUser',
          note: '保管员',
          type: 'String',
          validators: [notEmpty()]
        }
      ],
      showEdit: false,
      confirmEditLoading: false,
      formdata: this.initFormData(),
      canEdit: true
    }
  },
  mounted () {
    this.getGrains()
    this.getStorage()
    this.init()
  },
  methods: {
    formatCompact,
    formatTimeShow,
    addTimes () {
      this.formdata.times.push('')
    },
    deleteTimes (index) {
      this.formdata.times.splice(index, 1)
    },
    async validate () {
      const ret = []
      const refskey = Object.keys(this.$refs)
      for (let index = 0; index < refskey.length; index++) {
        const element = refskey[index]
        if (this.$refs[element]) {
          let item
          try {
            item = await this.$refs[element].validate()
          } catch (e) {
            item = e
          }
          if (item === true) {
            ret.push('')
          } else if (item === false) {
            ret.push('error')
          } else {
            ret.push(item)
          }
        }
      }
      const errors = ret.filter(element => element)
      if (errors.length > 0) {
        return false
      } else {
        const ret = this.checkTimeIntervals(this.sortUniq(this.formdata.times).filter(item => item))
        if (!ret) {
          this.$notification['error']({
            message: '定时设置',
            description: '设置的时间间隔需要在1小时以上，请检查设置的定时设置'
          })
        }
        return ret
      }
    },
    validateTimes (rule, value, callback) {
      if (this.formdata.times.some(item => item)) callback()
      else callback(new Error('请选择定时拍照时间'))
    },
    transformItems (list) {
      const json = {}
      list.forEach(element => {
        json[element.objectId] = element.name
      })
      return json
    },
    formatTimes () {
      const newTimes = this.sortUniq(this.formdata.times)
      if (newTimes.length !== this.formdata.times.length) {
        this.$notification['info']({
          message: '定时设置',
          description: '时间相同的设置只会保存一个'
        })
      }
      return newTimes.filter(item => item).join('@')
    },
    async getGrains () {
      const res = await await this.$tkParse.get('/classes/storageInfo', {
        params: {
          where: {
            types: 'grain'
          },
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      this.options[10].items = this.transformItems(res.data.results)
    },
    async getStorage () {
      const res = await this.$tkParse.get('/classes/storageInfo', {
        params: {
          where: {
            types: 'storage'
          },
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      this.options[11].items = this.transformItems(res.data.results)
    },
    async init () {
      await this.getStatisticalData()
      this.loading = false
    },
    async getStatisticalData () {
      const point = this.$tkParse.get('/aggregate/dropPlace', {
        params: {
          group: {
            objectId: '', // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1
            }
          },
          match: {
            store: this.warehouse.objectId
          } // 查询条件
        }
      })
      const eq = this.$tkParse.get('/aggregate/equipment', {
        params: {
          group: {
            objectId: '', // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1
            }
          },
          match: {
            grainstore: this.warehouse.objectId
          } // 查询条件
        }
      })
      const eqBug = this.$tkParse.get('/aggregate/equipment', {
        params: {
          group: {
            objectId: '', // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1
            }
          },
          match: {
            grainstore: this.warehouse.objectId,
            bugNum: { $gt: 0 }
          } // 查询条件
        }
      })
      const [pointRes, eqRes, eqBugRes] = await Promise.all([point, eq, eqBug])
      this.pointNum = pointRes.data.results[0].total
      this.eqNum = eqRes.data.results[0].total
      this.eqBugNum = eqBugRes.data.results[0].total
    },
    async handleDeleOk () {
      this.confirmDeleLoading = true
      const flag = await this.canDelete()
      if (flag) {
        await this.$tkParse.delete(
          `/classes/grainStorehouse/${this.warehouse.objectId}`
        )
        this.$emit('delete')
      } else {
        this.$notification['error']({
          message: '操作失败',
          description: '删除失败，此粮仓下存在设备，请先将其移除'
        })
      }
      this.showDele = false
      this.confirmDeleLoading = false
    },
    async canDelete () {
      const res = await this.$tkParse.get('/classes/equipment', {
        params: {
          where: { grainstore: this.warehouse.objectId }
        }
      })
      return res.data.results === 0
    },
    handleDeleCancel () {
      this.showDele = false
    },
    initFormData () {
      const data = {
        ...this.warehouse
      }
      data.times = (data.times || '').split('@')
      return data
    },
    showEditFunc (canEdit = true) {
      this.formdata = this.initFormData()
      this.canEdit = canEdit
      this.options.forEach(element => {
        element.disabled = !canEdit
      })
      this.showEdit = true
    },
    async handleEditOk () {
      const flag = await this.validate()
      if (flag) {
        const times = this.formatTimes()
        this.confirmEditLoading = true
        await this.$tkParse.put(
          `/classes/grainStorehouse/${this.warehouse.objectId}`,
          {
            name: this.formdata.name,
            expectation: this.formdata.expectation,
            reality: this.formdata.reality,
            type: this.formdata.type,
            subtype: this.formdata.subtype,
            length: this.formdata.length,
            width: this.formdata.width,
            height: this.formdata.height,
            diameter: this.formdata.diameter,
            grainType: this.formdata.grainType,
            storageType: this.formdata.storageType,
            incomeAt: this.formdata.incomeAt,
            leaveAt: this.formdata.leaveAt,
            times: times,
            custodianUser: this.formdata.custodianUser
          }
        )
        this.showEdit = false
        this.confirmEditLoading = false
        this.$emit('edit')
      }
    },
    handleEditCancel () {
      this.showEdit = false
    }
  }
}
</script>

<style scoped>
.card-tag {
  color: #94979c;
  background: #dde0e5;
  font-size: 12px;
  margin-left: 5px;
  border-radius: 3px;
  padding: 0px 3px;
}
::v-deep .ant-calendar-picker {
  width: 100%;
}
</style>
